import {
  Collapse,
  Icon,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { EOptionType } from "../../../../../../../interfaces/enums";
import { IFilterOption } from "../../../../../../../interfaces/dettaglio/models";
import { IFilterProps } from "../../interfaces";

function PeriodoFilter({ filters, setFilters }: IFilterProps) {
  const [open, setOpen] = useState<boolean>(false);


  const periodoFilter: IFilterOption | undefined = filters.find(
    (opt) => opt.type === EOptionType.periodo
  );

  const dateFrom = periodoFilter?.dateFrom ?? "";
  const dateTo = periodoFilter?.dateTo ?? "";

  const toggle = () => {
    setOpen(!open);
  };

  const updateFilter = (newFrom: string, newTo: string) => {

    if (!newFrom && !newTo) {
      setFilters(filters.filter((opt) => opt.type !== EOptionType.periodo));
      return;
    }

    const newFilter: IFilterOption = {
      type: EOptionType.periodo,
      ...periodoFilter,
      dateFrom: newFrom || null,
      dateTo: newTo || null,
    };

    setFilters([
     
      ...filters.filter((opt) => opt.type !== EOptionType.periodo),
      newFilter,
    ]);
  };

  const handleChangeFrom = (value: string) => {
    updateFilter(value, dateTo);
  };

  const handleChangeTo = (value: string) => {
    updateFilter(dateFrom, value);
  };


  const isSelected = !!dateFrom || !!dateTo;

  return (
    <>
      <ListItemButton onClick={toggle} selected={isSelected}>
        <ListItemIcon>
          <Icon
            className="fa-light fa-calendar-days"
            sx={{ overflow: "visible" }}
          />
        </ListItemIcon>
        <ListItemText primary="Periodo" />
        {open ? (
          <Icon
            className="fa-light fa-angle-up"
            fontSize="small"
            sx={{ overflow: "visible" }}
          />
        ) : (
          <Icon
            className="fa-light fa-angle-down"
            fontSize="small"
            sx={{ overflow: "visible" }}
          />
        )}
      </ListItemButton>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <List dense sx={{ pl: 5, pr: 1 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1, pb: 1 }}>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              label="Da data"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={dateFrom}
              onChange={(e) => handleChangeFrom(e.target.value)}
            />

            <TextField
              fullWidth
              variant="outlined"
              size="small"
              label="A data"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={dateTo}
              onChange={(e) => handleChangeTo(e.target.value)}
            />
          </Box>
        </List>
      </Collapse>
    </>
  );
}

export default PeriodoFilter;
